import Tool, { type ToolArgs } from './Tool';
import { ReactEditor } from 'slate-react';
import { Editor, Element, Transforms } from 'slate';
import EditorUtils from '../AhaEditorUtils/EditorUtils';

// Insert an empty paragraph above the current element.
class ToolInsertSpaceAbove extends Tool {
  static toolName = 'Insert space above';
  static iconClass = 'fa-regular fa-up-to-dotted-line';

  static action({ editor, element }: ToolArgs): void {
    if (!editor?.selection) return;

    let path;

    if (element) {
      path = ReactEditor.findPath(editor, element);
    } else {
      // Find the block element at current selection
      const entry = Editor.above(editor, {
        at: editor.selection,
        match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
        mode: 'highest',
      });
      path = entry && entry[1];
    }

    if (!path) return;

    Transforms.insertNodes(editor, EditorUtils.emptyParagraph(), {
      at: path,
    });

    Transforms.select(editor, path);
  }
}

export default ToolInsertSpaceAbove;
